import { Controller } from "react-hook-form";
import { accomodationTypes } from "../dropdownsData";
import {
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";

const AccommodationLine = ({
  id,
  onRemove,
  control,
  errors,
  getValues,
  selectedAccommodations,
  handleAccommodationChange,
}) => {
  const handleRemove = () => {
    const accommodationType = getValues(`accommodation${id}Type`);
    handleAccommodationChange(id, accommodationType, true);
    onRemove(id);
  };

  return (
    <div className="flex mb-1 sm:items-center flex-col sm:flex-row">
      <Controller
        render={({ field }) => (
          <FormControl
            fullWidth
            error={Boolean(errors[`accommodation${id}Type`])}
          >
            <InputLabel id={`accommodation-type-label-${id}`}>
              Accommodation Type <span className="text-orange">*</span>
            </InputLabel>
            <Select
              labelId={`accommodation-type-label-${id}`}
              id={`accommodation-type-${id}`}
              label={
                <div>
                  Accommodation Type <span className="text-orange">*</span>
                </div>
              }
              {...field}
              onChange={(e) => {
                field.onChange(e);
                handleAccommodationChange(id, e.target.value, false);
              }}
            >
              {accomodationTypes.map((accomodationType, index) => (
                <MenuItem
                  key={index}
                  value={accomodationType}
                  disabled={selectedAccommodations.some(
                    (a) => a.accomodationType === accomodationType
                  )}
                >
                  {accomodationType}
                </MenuItem>
              ))}
            </Select>
            {errors[`accommodation${id}Type`] && (
              <FormHelperText>
                {errors[`accommodation${id}Type`].message}
              </FormHelperText>
            )}
          </FormControl>
        )}
        name={`accommodation${id}Type`}
        control={control}
        rules={{
          required: "Accommodation Type is required",
        }}
      />
      <div className="sm:ml-1 w-full sm:w-15 mt-1 sm:mt-0">
        <Controller
          render={({ field }) => (
            <TextField
              {...field}
              error={Boolean(errors[`accommodation${id}Beds`])}
              helperText={
                errors[`accommodation${id}Beds`]
                  ? errors[`accommodation${id}Beds`].message
                  : null
              }
              label={
                <div>
                  Beds <span className="text-orange">*</span>
                </div>
              }
              className="w-full"
              type="number"
              inputProps={{ min: "0", step: "1" }}
            />
          )}
          name={`accommodation${id}Beds`}
          control={control}
          rules={{
            required: "Amount is required",
          }}
        />
      </div>
      <button
        type="button"
        className={`${
          id === 1 ? "semi-hidden" : ""
        } remove-line-button sm:ml-1 sm:mr-0-5 mt-0-5 sm:mt-0`}
        onClick={handleRemove}
      >
        X
      </button>
    </div>
  );
};

export default AccommodationLine;
